"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FragmentsPrefetcher = void 0;
class FragmentsPrefetcher {
    prefetchFragments(fragmentsInfo = {}, prefetchSettings = {}) {
        this.delayedCall(() => {
            const isExclusiveMode = Object.values(prefetchSettings).some(value => value === true);
            for (const fragmentName in fragmentsInfo) {
                if (!fragmentsInfo.hasOwnProperty(fragmentName)) {
                    continue;
                }
                const shouldBePrefetched = isExclusiveMode
                    ? prefetchSettings[fragmentName] === true
                    : prefetchSettings[fragmentName] !== false;
                if (shouldBePrefetched) {
                    this.prefetchFragment(fragmentsInfo[fragmentName]);
                }
            }
        });
    }
    delayedCall(callback) {
        window.requestAnimationFrame(() => {
            window.requestIdleCallback(callback);
        });
    }
    prefetchFragment(fragmentInfo) {
        for (const file of fragmentInfo.files) {
            this.addFilePrefetchToDocumentHead(file);
        }
    }
    addFilePrefetchToDocumentHead(src) {
        if (!document.querySelector(`[href="${src}"]`)) {
            const link = document.createElement('link');
            link.rel = 'prefetch';
            link.crossOrigin = 'anonymous';
            link.href = src;
            document.head.appendChild(link);
        }
    }
}
exports.FragmentsPrefetcher = FragmentsPrefetcher;
